<template>
    <div class="animated fadeIn">
    
      <div class="row">
        <div class="col-12">         
          <b-card>
            <v-server-table :columns="columns" url="/admin/gateReservations?status=HOLD,NEW,PAID" :options="options" :theme="theme" id="dataTable" ref="dataTable">
              <template slot="child_row" slot-scope="data">              
                <b-row>
                  <b-col lg="6">
                    <b-table :items="data.row.members" :fields="fields" striped></b-table>
                  </b-col>
                  <b-col lg="6">
                    <b-card title="Comments">{{ data.row.comments }}</b-card>
                  </b-col>
                </b-row>
              </template>
              <template slot="id_card_no" slot-scope="data">
                {{ data.row.id_card_no ? data.row.id_card_no : translateReason(data.row.id_card_reason) }}
              </template>
              <template slot="created_at" slot-scope="data">
                {{ $moment(data.row.created_at).format('YYYY-MM-DD') }}
              </template>              
              <template slot="is_child" slot-scope="data">
                {{ data.row.is_child ? 'Yes' : 'No' }}
              </template>
              <template slot="actions" slot-scope="data">
                <b-button v-if="data.row.checkin_status == 'No' && $auth.check('gate-reservations-checkin')" size="sm" class="mr-1" variant="success" @click="checkin(data.row)">Check In</b-button>                
              </template>
            </v-server-table>
          </b-card>
        </div><!--/.col-->
      </div><!--/.row-->     
      <div>
    <b-modal ref="modalGateVisitorEntry" title="Visitor Entry" hide-footer @hide="hideGateVisitoryEntry" size="lg">
      <gate-visitor-entry v-if="selectedReservation" :reservation="selectedReservation"  @cancel="cancelGateVisitorEntry" @success="successGateVisitoryEntry" />
    </b-modal>
      </div>
    </div>

    </template>
    
    <script>
    import { mapState, mapActions } from 'vuex'
    import Vue from 'vue'    
    import GateVisitorEntry from '../entrygate/GateVisitorEntry.vue'
    export default {
      name: 'GateReservationsList',
      components: {
        GateVisitorEntry,
      },
      computed: {     
      },
      data: function() {
        return {
          allowMultiple: false,
          selectedReservationObject: {},
          selectedReservation: null,
          selectedAutoReservation: null,
          fields: ['name', 'age', 'i_card_number'],
          columns: [
            'event_type.name',
            'id_card_no',
            'application_number',
            'applicant_name',
            'checkin_status',
            'customer.city',
            'members_count',           
            'arrival_date', 
            'actions'
          ],
          options: {
            headings: {
              'event_type.name': 'Bhandara/Satsang',
              id_card_no: 'Id Card (or reason)',
              application_number: 'Reservation Reference',
              applicant_name: 'Applicant',
              'customer.city': 'City',
              members_count: 'Members',
              arrival_date: 'Arrival',
              departure_date: 'Departure',   
              checkin_status: 'Checked In?'                                       
            },
            sortable: ['arrival_date', 'departure_date', 'status', 'members_count'],
            filterable: ['application_number'],
            sortIcon: {
              base: 'fa',
              up: 'fa-sort-asc',
              down: 'fa-sort-desc',
              is: 'fa-sort'
            },
            pagination: {
              chunk: 5,
              edge: true,
              nav: 'scroll'
            },
            perPage: 25,
            responseAdapter: function(response) {
              var data = this.getResponseData(response);
              return {
                data: data.data,
                count: data.meta.pagination.total
              }
            },
            cellClasses:{
              is_child: [
                {
                    class:'font-weight-bold',
                    condition: row => row.is_child == 1
                }
              ]
            }
          },
          useVuex: false,
          theme: 'bootstrap4',
          template: 'default',
        }
      },
      methods: {
        showGateVisitorEntry(reservation) {
      this.selectedReservation = reservation   
      this.$refs.modalGateVisitorEntry.show();
    },
    hideGateVisitoryEntry(){
      this.selectedReservation = null   
      this.$refs.modalGateVisitorEntry.hide();
    },
    successGateVisitoryEntry(res){
      this.$refs.modalGateVisitorEntry.hide();
      this.$store.dispatch('reservations/updateCheckinReservation', {id: res.id, type:'GATE'})
          .then((response) => {
            try{            
            if(response.data != null && response.data.success == false){
              this.showErrorMsg({
                message: response.data.error
              })
            }
            else{
              this.showSuccessMsg()
            this.$refs.dataTable.refresh()
            }
          }catch(exception){
            this.showErrorMsg({
                message: exception
              })
          }
            
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else {
              this.showErrorMsg()
            }
          })
        //  this.selectedReservation = null   
    },
    cancelGateVisitorEntry(){
      this.selectedReservation = null   
      this.$refs.modalGateVisitorEntry.hide();
    },
        checkin(row) {     
          console.log(row);      
           this.showGateVisitorEntry(row);
    
        },    
        translateReason(reason) {
          switch (reason) {
            case 'NEW_TO_SATSANG':
              return 'New to Satsang'
            case 'SUPPORT_ELDER_PERSON':
              return 'Support to elder person'
            case 'CHILD':
              return 'Child'
          }
          return ''
        }
      },
    }
    </script>
    